export const TANQUE_CHEIO_TYPE_ID = 4;
